import API from "../../../store/api";
import { authLogout } from "../../../store/actions/authActions";
import { setContent, clearContent } from "../../../store/actions/contentActions";
import { setMessage } from '../../../store/actions/dialogActions';

export const getAllContent = (bearerAuth) => {
  return async dispatch => {
    API.get("/api/portal/contents")
      .set('Authorization', `Bearer ${bearerAuth}`)
      .ok(res => res.status < 500)
      .then((response) => {
        if (response.status === 200) {
          dispatch(setContent(response.body));
        } else if (response.status === 401) {
          dispatch(clearContent);
          dispatch(authLogout);
        } else {
          dispatch(clearContent)
        }
      }).catch((error) => {
        let message = 'An error has occurred';
        if (error.message) {
          message = error.message;
        }
        if (error.response && error.response.body) {
          if (error.response.body.messages) {
            message = error.response.body.messages.toString();
          } 
        }
        dispatch(setMessage({
          title: 'Content Retrieval Failed',
          message: message,
          type: 'ERR',
        }))
        dispatch(clearContent);
      })
  }
}
